<!-- text -->
<div class="text-2xl py-3 px-5 font-bold text-gray-500">Definição de Embates</div>
<!-- inputs TODO: set automatico de casa ou fora pelo cabeça de chave -->
<form [formGroup]="inputsForm" class="grid grid-cols-11 w-full gap-4 px-6 pb-4">
  <sigecom-new-dropdown
    required
    #participantDropdown
    formControlName="ichNrId"
    optionIdentify="ichNrId"
    optionLabel="ichNrId"
    label="Participante"
    class="w-full col-span-3"
    [options]="participantsPage().content || []"

    searchble
    (searchChange)="setSearch($event)"

    paged
    [currentPage]="participantsPageable().page"
    [totalPages]="participantsPage().totalPages ||  1"
    (pageChange)="changePage($event)"
  />

  <sigecom-new-dropdown
    formControlName="gameSide"
    optionIdentify="value"
    class="w-full col-span-2"
    [options]="locationOptions"
    optionLabel="label"
    label="Posição do Participante"
    required
  />
  <!-- TODO: trazer novo componente e levar melhorias para os demais -->
  <sigecom-new-dropdown
    formControlName="entNrId"
    [options]="jogos"
    label="Jogo"
    class="flex flex-col col-span-2"
  />

  <button (click)="submitData()" class="text-white font-medium whitespace-nowrap col-span-2 rounded-lg px-6 items-center justify-center flex flex-row bg-blue-800" >
    <p>ADICIONAR EMBATE</p>
    <fa-icon class="ml-2" icon="plus"/>
  </button>
  <button (click)="printData()" class="text-blue-800 border-2 border-blue-800 bg-white font-medium whitespace-nowrap col-span-2 rounded-lg px-6 items-center justify-center flex flex-row " >
    <p>SORTEIO AUTOMÁTICO</p>
    <fa-icon class="ml-2" icon="shuffle"/>
  </button>
</form>
<!-- container de embates -->
<div class="overflow-auto select-none" panDirective>
  <div class="relative w-screen h-[650px]">
    <svg #svgContainer></svg>
    <div *ngIf="clash">

      <div *ngFor="let itemArray of clash.listEmbates; let j=index">

        <!-- <div *ngFor="let item of clash.listEmbates[j]; let i=index">
          <div *ngIf="item.embNrEtapa==clash.listEmbates[0][0].embNrEtapa"
          class="absolute bg-gray-300 rounded-md border-2 border-white text-blue-900 font-medium flex justify-center items-center text-center w-[120px]"
          [style.top.px]="calculateTop(i*2, item.embNrEtapa) + 55"
          [style.left.px]="calculateLeft(j>(clash.listEmbates.length/2)?j+2:j)"
          >
            {{'Jogo '+ (j>(clash.listEmbates.length/2)?(item.embNrEtapa/2+i+1):i+1)}} </div>
          <div
          #elements
          [id]="j"
          class="w-[120px] h-[50px] text-center leading-[50px] absolute"
          [style.top.px]="calculateTop(i*2, item.embNrEtapa)"
          [style.left.px]="calculateLeft(j>(clash.listEmbates.length/2)?j+2:j)"
          >
            <sigecom-clash-box [name]="'a'" [inscricao]="item.embObjInscricaoA" [isHead]="isHead(item, 'A')" [won]="isWon('A', item.embTxVencedor)" [bye]="isBye(item)" />
          </div>

          <div *ngIf="item.embNrEtapa==1">
            <div class="absolute text-6xl text-center w-[120px]" [style.top.px]="calculateTop(i*2+(item.embNrEtapa==1?0:1), item.embNrEtapa, true) - 100" [style.left.px]="calculateLeft(j+1)">
              🏆
            </div>
            <div
            #winner
            class="w-[120px] h-[50px] text-center leading-[50px] absolute"
            [style.top.px]="calculateTop(i*2+(item.embNrEtapa==1?0:1), item.embNrEtapa, true)"
            [style.left.px]="calculateLeft(j+1)">
              <sigecom-clash-box name="winner"/>
            </div>
          </div>

          <div
          #elements
          [id]="j"
          class="w-[120px] h-[50px] text-center leading-[50px] absolute"
          [style.top.px]="calculateTop(i*2+(item.embNrEtapa==1?0:1), item.embNrEtapa)"
          [style.left.px]="calculateLeft(j>=(clash.listEmbates.length/2)-1?j+2:j)">
            <sigecom-clash-box [name]="'a'" [inscricao]="item.embObjInscricaoB" [isHead]="isHead(item, 'B')" [won]="isWon('B', item.embTxVencedor)" [bye]="isBye(item)" />
          </div>

        </div> -->
      </div>
    </div>
  </div>
</div>
<div class="h-4"></div>
